// @ts-check

import { postDigital, redirectToWarenkorb } from "../../../common/api";
import { betragInCent, performMinMaxValidation } from "../../../common/betragFunctions";
import { setOneTimeValidationMessage } from "./additionalValidation";
import { disable, enable, setLoading, resetForm } from "../../../common/fieldUtils";
import { wrapAndSliceText } from "./textareaRowLimit";

export { createSubmitListener };

function createSubmitListener(context) {
  return (event) => {
    event.preventDefault();
    event.stopPropagation();

    const {
      warenkorbButton, absender, empfaenger, betrag, email, abweichenderEmpfaenger, hinweis, nachricht, carousel
    } = context;
    const fields = [warenkorbButton, absender, empfaenger, betrag, email, nachricht];

    performMinMaxValidation(betrag);
    if (!betrag.checkValidity()) {
      betrag.reportValidity();
      return;
    }

    disable(...fields);
    setLoading(warenkorbButton, true);

    postDigital({
      artikelnummer: carousel.selectedCard,
      email: email.value,
      abweichenderEmpfaenger: abweichenderEmpfaenger.getAttribute("abweichender-empfaenger"),
      von: absender.value,
      fuer: empfaenger.value,
      preis: betragInCent(betrag),
      nachricht: wrapAndSliceText(nachricht.value)
    }).then((result) => {
      return result.json();
    }).then((result) => {
      const submitUrl = result.submitUrl;
      delete result.submitUrl;
      redirectToWarenkorb(submitUrl, result);
      resetForm(warenkorbButton, ...fields);
    }).catch((e) => {
      e.json()
        .then((errorData) => {
          if (errorData.feld === "email") {
            enable(...fields);
            setLoading(warenkorbButton, false);
            setOneTimeValidationMessage(email, "Die E-Mail-Adresse ist ungültig.");
          } else {
            throw new Error("Es ist ein Problem aufgetreten.");
          }
        })
        .catch((e) => {
          console.error(e);
          hinweis.classList.remove("hidden");
          hinweis.scrollIntoView({ behavior: "smooth", inline: "center", block: "center" });
          setLoading(warenkorbButton, false);
        });
    });
  };
}
